import { createFileRoute } from "@tanstack/react-router";

import { PrivacySettings } from "../components/settings/PrivacySettings";

export const Route = createFileRoute("/settings/privacy")({
  component: PrivacySettings,
});
